import { asyncAction } from './common';
import { executeUsage, executeUsageCsv } from '../api/usage';

export const toggleUsageCalcTotal = () => ({
  type: 'TOGGLE_USAGE_CALC_TOTAL',
});

export const toggleUsageTrendLine = () => ({
  type: 'TOGGLE_USAGE_TREND_LINE',
});

export const toggleUsageAverageLine = () => ({
  type: 'TOGGLE_USAGE_AVERAGE_LINE',
});

export const toggleUsageMedianLine = () => ({
  type: 'TOGGLE_USAGE_MEDIAN_LINE',
});

export const toggleUsageAdaptive = () => ({
  type: 'TOGGLE_USAGE_ADAPTIVE',
});

export const setUsageColumnChartSorting = (sorting) => ({
  type: 'CHANGE_USAGE_COLUMN_CHART_SORTING',
  sorting,
});

export const setUsageQueryType = (queryType) => ({
  type: 'CHANGE_USAGE_QUERY_TYPE',
  queryType,
});

export const changeUsageView = (view) => ({
  type: 'CHANGE_USAGE_VIEW',
  view,
});

export const setUsageSplitColumn = (splitColumn) => ({
  type: 'USAGE_COMPOSE_SET_SPLIT_COLUMN',
  splitColumn,
});

export const setUsageGroupColumn = (groupColumn) => ({
  type: 'USAGE_COMPOSE_SET_GROUP_COLUMN',
  groupColumn,
});

export const setUsageExecuteId = (executeId) => ({
  type: 'SET_USAGE_EXECUTE_ID',
  executeId,
});

export const executeUsageQueries = (executeId) =>
  asyncAction('EXECUTE_USAGE_QUERIES', executeUsage(executeId));

export const executeUsageQueryCsv = () => asyncAction('EXECUTE_USAGE_QUERY_CSV', executeUsageCsv());
